function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_143",
  "data-name": "Path 143",
  d: "M133.161,0C59.974,0,0,59.974,0,133.161S59.974,266.321,133.161,266.321s133.161-59.974,133.161-133.161S206.347,0,133.161,0Z",
  fill: "rgba(147,147,147,0.69)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_144",
  "data-name": "Path 144",
  d: "M389.161,133.161c0,73.186-59.974,133.161-133.161,133.161V0C329.186,0,389.161,59.974,389.161,133.161Z",
  transform: "translate(-122.839)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_145",
  "data-name": "Path 145",
  d: "M148.036,31A117.036,117.036,0,1,0,265.071,148.036,117.078,117.078,0,0,0,148.036,31Z",
  transform: "translate(-14.875 -14.875)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_146",
  "data-name": "Path 146",
  d: "M373.036,148.036A117.078,117.078,0,0,1,256,265.071V31A117.078,117.078,0,0,1,373.036,148.036Z",
  transform: "translate(-122.839 -14.875)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_147",
  "data-name": "Path 147",
  d: "M247.058,125.688a45.367,45.367,0,0,0-49.936-49.936,45.325,45.325,0,0,0-70.534,0,45.367,45.367,0,0,0-49.936,49.936,45.163,45.163,0,0,0,0,70.376A45.366,45.366,0,0,0,126.588,246a45.325,45.325,0,0,0,70.534,0,45.366,45.366,0,0,0,49.936-49.936,45.163,45.163,0,0,0,0-70.376Z",
  transform: "translate(-28.695 -28.262)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_148",
  "data-name": "Path 148",
  d: "M358.055,160.8A44.923,44.923,0,0,1,341.2,196.065,45.366,45.366,0,0,1,291.266,246,45.388,45.388,0,0,1,256,262.854V58.9a45.389,45.389,0,0,1,35.267,16.854A45.367,45.367,0,0,1,341.2,125.689,44.844,44.844,0,0,1,358.055,160.8Z",
  transform: "translate(-122.839 -28.263)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "Group_28",
  "data-name": "Group 28",
  transform: "translate(132.087 131.484)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_149",
  "data-name": "Path 149",
  d: "M358.334,301.466l-80.142-34.349,6.142-14.34,80.142,34.349Z",
  transform: "translate(-265.574 -252.777)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_150",
  "data-name": "Path 150",
  d: "M287.963,368.842l-34.028-85.064,14.492-5.791,34.029,85.064Z",
  transform: "translate(-253.935 -264.874)",
  fill: "rgba(147,147,147,0.69)"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "Group_29",
  "data-name": "Group 29",
  transform: "translate(33.924 29.375)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_151",
  "data-name": "Path 151",
  d: "M177.337,365.586,163,359.445l35.05-81.78,14.34,6.142Z",
  transform: "translate(-112.137 -162.611)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_152",
  "data-name": "Path 152",
  d: "M74.76,299.071l-5.791-14.493,79.784-31.918,5.79,14.492Z",
  transform: "translate(-67.018 -150.612)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_153",
  "data-name": "Path 153",
  d: "M147.159,211.811l-81.94-35.119,6.141-14.34L153.3,197.471Z",
  transform: "translate(-65.219 -107.279)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_154",
  "data-name": "Path 154",
  d: "M199.046,148.662l-34.555-86.4,14.493-5.79,34.554,86.4Z",
  transform: "translate(-112.854 -56.474)",
  fill: "rgba(147,147,147,0.69)"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "Group_30",
  "data-name": "Group 30",
  transform: "translate(131.789 31.364)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_155",
  "data-name": "Path 155",
  d: "M267.7,150.672l-14.34-6.142L289.4,60.3l14.34,6.142Z",
  transform: "translate(-253.363 -60.297)",
  fill: "rgba(147,147,147,0.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_156",
  "data-name": "Path 156",
  d: "M283.587,212.212l-6.142-14.34,80.92-34.684,6.141,14.34Z",
  transform: "translate(-264.919 -109.668)",
  fill: "rgba(147,147,147,0.69)"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_157",
  "data-name": "Path 157",
  d: "M234.407,211a23.407,23.407,0,1,0,23.407,23.407A23.375,23.375,0,0,0,234.407,211Z",
  transform: "translate(-101.247 -101.247)",
  fill: "rgba(147,147,147,0.69)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_158",
  "data-name": "Path 158",
  d: "M279.407,234.407A23.375,23.375,0,0,1,256,257.814V211A23.375,23.375,0,0,1,279.407,234.407Z",
  transform: "translate(-122.839 -101.247)",
  fill: "rgba(147,147,147,0.69)"
});

function SvgOrangeSlice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "orange-slice",
    xmlns: "http://www.w3.org/2000/svg",
    width: 266.321,
    height: 266.321,
    viewBox: "0 0 266.321 266.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeSlice);
export default __webpack_public_path__ + "static/media/orange-slice.687cf17e.svg";
export { ForwardRef as ReactComponent };